import { Spinner, Text } from '@viapeople/components'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface RatingDistributionChartProps {
	data: Array<{ rating: number; count: number; percent: number }> | undefined
	loading?: boolean
}

export function RatingDistributionChart({ data, loading }: RatingDistributionChartProps) {
	if (loading) {
		return (
			<div data-testid='rating-distribution-loading' className='flex items-center justify-center h-64'>
				<Spinner />
			</div>
		)
	}
	if (!data || data.every((d) => d.count === 0)) {
		return (
			<div data-testid='rating-distribution-empty' className='flex items-center justify-center h-64 text-neutral-500'>
				No completed evaluations match the current filters.
			</div>
		)
	}

	const chartData = data.map((d) => ({ ...d, label: `${d.rating} stars` }))

	return (
		<div data-testid='rating-distribution-chart' className='w-full'>
			<Text variant='small' weight='semibold' className='mb-2'>
				Overall Rating Distribution
			</Text>
			<ResponsiveContainer width='100%' height={300}>
				<BarChart data={chartData} margin={{ top: 16, right: 24, left: 16, bottom: 24 }}>
					<CartesianGrid strokeDasharray='3 3' stroke='#e5e7eb' />
					<XAxis dataKey='label' tick={{ fontSize: 12 }} />
					<YAxis tick={{ fontSize: 12 }} />
					<Tooltip
						contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
						formatter={
							((value: number | undefined, _name: unknown, item: { payload?: { percent?: number } }) =>
								value != null
									? [`${value} (${item.payload?.percent ?? 0}%)`, 'Employees']
									: ['-', 'Employees']) as never
						}
					/>
					<Bar dataKey='count' fill='#2563eb' radius={[2, 2, 0, 0]} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}
